import { render, staticRenderFns } from "./salesInvoice.vue?vue&type=template&id=5cbc5f3d&scoped=true&"
import script from "./salesInvoice.vue?vue&type=script&lang=js&"
export * from "./salesInvoice.vue?vue&type=script&lang=js&"
import style0 from "./salesInvoice.vue?vue&type=style&index=0&id=5cbc5f3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc5f3d",
  null
  
)

export default component.exports